const mutations = {
    setFlexworkers(state,payload) {
        state.flexworkers = payload
    },
    setFlexworker(state,payload) {
        state.flexworker = payload
    }
}

export default mutations

